import { AMZ_FILTERTED_STORENAMES } from 'constants/amazon';

export const convertAmazonPayTitle = (storeName: string) => {
  return AMZ_FILTERTED_STORENAMES.includes(storeName);
};
